import styled from 'styled-components';

export const Plus = styled.span`
  cursor: pointer;
  position: absolute;
  right: 25px;
  top: 15px;

  &:after {
    content: '' '';
    height: 12px;
    left: 7px;
    position: absolute;
    width: 2px;
    transform: matrix(6.12323e-17, 1, -1, 6.12323e-17, 0, 0);
    background: ${props => (props.open ? 'white' : '#9B9B9B')} none repeat
      scroll 0% 0% / auto padding-box border-box;
  }
  &:before {
    display: ${props => (props.open ? 'none' : 'block')};
    content: '' '';
    height: 12px;
    left: 7px;
    position: absolute;
    width: 2px;
    background: #9b9b9b none repeat scroll 0% 0% / auto padding-box border-box;
  }
`;

export const ToolTipKidFriendly = styled.div`
  box-sizing: border-box;
  left: 0;
  position: absolute;
  top: 48px;
  width: ${({ isPolicy, isDedicated }) =>
    isPolicy ? '350px' : isDedicated ? '420px' : '253px'};
  z-index: 99;
  background: rgb(255, 255, 255) none repeat scroll 0% 0% / auto padding-box
    border-box;
  border: 1px solid rgb(213, 213, 213);
  font: normal normal 500 normal 16px / 24px ${({ theme }) => theme.fonts.primary};

  transform: scale(0);

  padding: 10px 15px;
  transition: all 0.2s cubic-bezier(0.75, -0.02, 0.2, 0.97) 0s;
  .tooltip-arrow {
    height: 8px;
    left: 5px;
    position: absolute;
    top: -9px;
    margin: 0px 4.8px;

    &:after {
      box-sizing: border-box;
      content: '';
      left: 0px;
      position: absolute;
      right: 0px;
      top: 1px;
      width: 16px;
      border-top: 0px solid rgba(0, 0, 0, 0);
      border-right: 8px solid rgba(0, 0, 0, 0);
      border-bottom: 8px solid rgb(255, 255, 255);
      border-left: 8px solid rgba(0, 0, 0, 0);
    }
    &:before {
      box-sizing: border-box;
      content: '';
      display: block;
      height: 8px;
      border-right: 8px solid rgba(0, 0, 0, 0);
      border-bottom: 8px solid rgba(0, 0, 0, 0.25);
      border-left: 8px solid rgba(0, 0, 0, 0);
    }
  }
  .desc {
    text-align: start !important;
    color: rgb(104, 104, 104);
    font-family: ${({ theme }) => theme.fonts.primary};
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 15px;
    text-align: center;
    letter-spacing: 0.25px;
    margin: 0;
  }
  .learn-more {
    color: rgb(104, 104, 104);
    font: normal normal 500 normal 16px / 24px ${({ theme }) => theme.fonts.primary};
    margin: 8px 0px 0px;
  }
  .learn-more-link {
    border-bottom: 1px solid grey;
    color: rgb(104, 104, 104);
    text-decoration: none solid rgb(104, 104, 104);
    font: normal normal 500 normal 12px / 18px ${({ theme }) => theme.fonts.primary};

    &:hover {
      color: ${({ theme }) => theme.colors.french};
    }
  }
`;

export const TooltipFlag = styled.div`
  box-sizing: border-box;
  left: 0;
  position: absolute;
  top: 48px;
  width: 135px;
  z-index: 99;
  background: rgb(255, 255, 255) none repeat scroll 0% 0% / auto padding-box
    border-box;
  border: 1px solid rgb(213, 213, 213);
  font: normal normal 500 normal 16px / 24px ${({ theme }) => theme.fonts.primary};

  transform: scale(0);

  padding: 10px 15px;
  transition: all 0.2s cubic-bezier(0.75, -0.02, 0.2, 0.97) 0s;
  .tooltip-arrow {
    height: 8px;
    left: 5px;
    position: absolute;
    top: -9px;
    margin: 0px 4.8px;

    &:after {
      box-sizing: border-box;
      content: '';
      left: 0px;
      position: absolute;
      right: 0px;
      top: 1px;
      width: 16px;
      border-top: 0px solid rgba(0, 0, 0, 0);
      border-right: 8px solid rgba(0, 0, 0, 0);
      border-bottom: 8px solid rgb(255, 255, 255);
      border-left: 8px solid rgba(0, 0, 0, 0);
    }
    &:before {
      box-sizing: border-box;
      content: '';
      display: block;
      height: 8px;
      border-right: 8px solid rgba(0, 0, 0, 0);
      border-bottom: 8px solid rgba(0, 0, 0, 0.25);
      border-left: 8px solid rgba(0, 0, 0, 0);
    }
  }
  .desc {
    text-align: start !important;
    color: rgb(104, 104, 104);
    font-family: ${({ theme }) => theme.fonts.primary};
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 15px;
    text-align: center;
    letter-spacing: 0.25px;
    margin: 0;
  }
  .learn-more {
    color: rgb(104, 104, 104);
    font: normal normal 500 normal 16px / 24px ${({ theme }) => theme.fonts.primary};
    margin: 8px 0px 0px;
  }
  .learn-more-link {
    border-bottom: 1px solid grey;
    color: rgb(104, 104, 104);
    text-decoration: none solid rgb(104, 104, 104);
    font: normal normal 500 normal 12px / 18px ${({ theme }) => theme.fonts.primary};

    &:hover {
      color: ${({ theme }) => theme.colors.french};
    }
  }
`;
